document.addEventListener("DOMContentLoaded", function () {
    const baseUrl = 'https://boozoom-middleware.wtdevsite.com'
    const customerId = document.getElementById("customerId").value;

    if (customerId.trim() != "") {

        const discountApi = `${baseUrl}/shopify/api/customer/discount/${customerId}`

        const fetchDiscount = async () => {
            try {
                const response = await fetch(discountApi, {
                    method: 'GET', // or 'POST', 'PUT', etc. if required
                    headers: {
                        'Content-Type': 'application/json',
                        // Add any additional headers if required, e.g., Authorization
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();

                if (!data) {
                    return null;
                }

                return data.code;
                // Process the data as needed
            } catch (error) {
                console.error("Error fetching discount data:", error);
            }
        }

        const applyDiscount = async (discountCode) => {
            if (discountCode) {
                // Save the discount code as a session cookie
                document.cookie = `discount_code=${discountCode}; path=/`;

                // Send GET request to "/discount/[discountcode]"
                await fetch(`/discount/${discountCode}`)
                .then(function() {
                    // After the discount code has been applied, force the cart to update so the discount is visible for anything that calls the .cart.json file e.g. an AJAX draw cart. 
                    return fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            updates: {},
                        }),
                    });
                })
                .catch(function(error) {
                    console.error('Error:', error);
                });
            }
        }

        const startDiscount = async() => {
            const discountCode = await fetchDiscount()
            if (discountCode) {
                console.log(discountCode)
                await applyDiscount(discountCode)
            }
        }

        startDiscount()
        
    } else {
        console.log('No Customer')
    }
})